import { createSlice } from '@reduxjs/toolkit'
import { VALIDATION } from 'app/types'
import {
  DUE_DATE,
  VENDOR,
  DEPARTMENT,
  PARTICULARS,
  PROJECT,
  SUB_PROJECT,
  RELEASING_CENTER,
  SUPPORTING_DOCUMENTS,
  GROSS_PRICE_PER_ITEM
} from 'types'

const initialState = {
  [DUE_DATE]: ['', ''],
  [VENDOR]: ['', ''],
  [DEPARTMENT]: ['', ''],
  [PARTICULARS]: ['', ''],
  [PROJECT]: ['', ''],
  [SUB_PROJECT]: [false, ''],
  [RELEASING_CENTER]: [false, ''],
  [GROSS_PRICE_PER_ITEM]: ['', ''],
  [SUPPORTING_DOCUMENTS]: ['', '']
}
export const validationSlice = createSlice({
  name: VALIDATION,
  initialState: { ...initialState },
  reducers: {
    setValidation: (state, action) => {
      const { payload } = action
      const { fieldName, error, message } = payload
      state[fieldName] = [error, message]
    },
    clearValidations: state => {
      state[DUE_DATE] = ['', '']
      state[VENDOR] = ['', '']
      state[DEPARTMENT] = ['', '']
      state[PARTICULARS] = ['', '']
      state[PROJECT] = ['', '']
      state[SUB_PROJECT] = [false, '']
      state[RELEASING_CENTER] = [false, '']
      state[GROSS_PRICE_PER_ITEM] = ['', '']
      state[SUPPORTING_DOCUMENTS] = ['', '']
    }
  }
})

export const { setValidation, clearValidations } = validationSlice.actions
export const selectValidationSlice = state => state[VALIDATION]
export default validationSlice.reducer
